export const counter = () => {
    const countdownAll = document.querySelectorAll(".counter");
    if (!countdownAll.length) return;

    const pad = (n) => String(n).padStart(2, "0");

    const stops = [
        { pos: 0, color: [25, 175, 27] },
        { pos: 33, color: [255, 255, 0] },
        { pos: 66, color: [255, 124, 0] },
        { pos: 100, color: [255, 0, 0] },
    ];

    const getGradientColor = (percent) => {
        percent = Math.max(0, Math.min(100, percent));

        let left = stops[0];
        let right = stops[stops.length - 1];

        for (let i = 0; i < stops.length - 1; i++) {
            if (percent >= stops[i].pos && percent <= stops[i + 1].pos) {
                left = stops[i];
                right = stops[i + 1];
                break;
            }
        }

        const t = (percent - left.pos) / (right.pos - left.pos);

        const rgb = left.color.map((c, i) =>
            Math.round(c + (right.color[i] - c) * t)
        );

        return `rgb(${rgb.join(",")})`;
    };

    countdownAll.forEach((item) => {
        const countdownEl = item.querySelector('.counter__countdown');
        const startString = countdownEl.dataset.start;
        const endString = countdownEl.dataset.end;

        if (!startString || !endString) return;

        const startTime = new Date(startString).getTime();
        const endTime = new Date(endString).getTime();

        if (isNaN(startTime) || isNaN(endTime) || endTime <= startTime) {
            console.warn("Invalid counter dates:", startString, endString);
            return;
        }

        const daysEl = countdownEl.querySelector(".days");
        const hoursEl = countdownEl.querySelector(".hours");
        const minutesEl = countdownEl.querySelector(".minutes");
        const secondsEl = countdownEl.querySelector(".seconds");

        const progressEl = item.querySelector(".counter__progress");
        const thumbEl = item.querySelector(".counter__circle--thumb");

        let prevDays, prevHours, prevMinutes, prevSeconds;

        const updateText = (el, prev, value) => {
            if (el && prev !== value) {
                el.textContent = pad(value);
                return value;
            }
            return prev;
        };

        const updateProgress = (percent) => {
            if (!progressEl || !thumbEl) return;

            const width = progressEl.clientWidth;
            const x = (percent / 100) * width;

            thumbEl.style.left = `${x}px`;
            thumbEl.style.backgroundColor = getGradientColor(percent);
            thumbEl.style.transform = `translate(${-percent}%, -50%)`;

            countdownEl.style.left = `${x}px`;
            countdownEl.style.transform = `translateX(${-percent}%)`;
        };

        // const update = () => {
        //     const now = Date.now();
        //     const timeLeft = endTime - now;

        //     const totalDuration = endTime - startTime;
        //     const elapsed = now - startTime;

        //     const progress = Math.max(0, Math.min(100, (elapsed / totalDuration) * 100));

        //     updateProgress(progress);

        //     if (timeLeft <= 0) {
        //         prevDays = updateText(daysEl, prevDays, 0);
        //         prevHours = updateText(hoursEl, prevHours, 0);
        //         prevMinutes = updateText(minutesEl, prevMinutes, 0);
        //         prevSeconds = updateText(secondsEl, prevSeconds, 0);

        //         updateProgress(100);

        //         return false;
        //     }

        //     const days = Math.floor(timeLeft / 86400000);
        //     const hours = Math.floor((timeLeft / 3600000) % 24);
        //     const minutes = Math.floor((timeLeft / 60000) % 60);
        //     const seconds = Math.floor((timeLeft / 1000) % 60);

        //     prevDays = updateText(daysEl, prevDays, days);
        //     prevHours = updateText(hoursEl, prevHours, hours);
        //     prevMinutes = updateText(minutesEl, prevMinutes, minutes);
        //     prevSeconds = updateText(secondsEl, prevSeconds, seconds);

        //     return true;
        // };

        const update = () => {
            const now = Date.now();
            const totalDuration = endTime - startTime;
            const timeLeft = endTime - now;

            if (timeLeft <= 0) {
                prevDays = updateText(daysEl, prevDays, 0);
                prevHours = updateText(hoursEl, prevHours, 0);
                prevMinutes = updateText(minutesEl, prevMinutes, 0);
                prevSeconds = updateText(secondsEl, prevSeconds, 0);

                updateProgress(100);
                return false;
            }

            const elapsed = totalDuration - timeLeft;
            const progress = Math.max(
                0,
                Math.min(100, (elapsed / totalDuration) * 100)
            );

            updateProgress(progress);

            const days = Math.floor(timeLeft / 86400000);
            const hours = Math.floor((timeLeft / 3600000) % 24);
            const minutes = Math.floor((timeLeft / 60000) % 60);
            const seconds = Math.floor((timeLeft / 1000) % 60);

            prevDays = updateText(daysEl, prevDays, days);
            prevHours = updateText(hoursEl, prevHours, hours);
            prevMinutes = updateText(minutesEl, prevMinutes, minutes);
            prevSeconds = updateText(secondsEl, prevSeconds, seconds);

            return true;
        };
        update();

        const interval = setInterval(() => {
            const shouldContinue = update();
            if (!shouldContinue) clearInterval(interval);
        }, 1000);

        window.addEventListener("resize", update);
    });
};